export default __webpack_public_path__ + "static/media/List Options.acc00ff8.svg";